<template>
  <picture
    data-ui="generic-image-component"
  >
    <!-- XS (always high res) -->
    <source
      media="(max-width: 767px)"
      :srcset="xsSrcSet"
      :sizes="renderedSizeMobile"
    >

    <!-- LG - High res - Order Matters! -->
    <source
      media="(min-width: 1232px)"
      :srcset="lgSrcSet"
      :sizes="renderedSizeDesktop"
    >

    <!-- MD -->
    <source
      media="(min-width: 992px)"
      :srcset="mdSrcSet"
      :sizes="renderedSizeMobile"
    >

    <!-- SM -->
    <source
      media="(min-width: 768px)"
      :srcset="smSrcSet"
      :sizes="renderedSizeMobile"
    >

    <!-- LG - low res -->
    <cdr-img
      v-if="image.src"
      ref="img"
      :alt="image.alt"
      :src="`${image.src}`"
      :loading="loading"
      :fetchpriority="computedFetchPriority"
      :class="[customClasses]"
      :aria-hidden="ariaHidden"
    />
  </picture>
</template>

<script>
import { CdrImg } from '@rei/cedar';

const xsSizes = [350, 550, 700, 800, 900];
const smSizes = xsSizes.concat([1200, 2000]);
const mdSizes = smSizes;
const lgSizes = mdSizes.concat([3000, 4000]);
const generateResizeSrcSet = (sizes = [], src = '') => sizes.reduce((acc, size) => `${acc}${src}?im=Resize,width=${size},`, '');

export default {
  /* c8 ignore start */
  name: 'GenericImageComponent',
  components: { CdrImg },
  props: {
    image: { type: Object, required: true, default: (() => {}) },
    useBannerCrop: { type: Boolean, required: false, default: false },
    ratio: { type: String, required: false, default: '' },
    radius: { type: String, required: false, default: '' },
    renderedSizes: { type: Object, required: false, default: (() => ({ mobile: '100vw', desktop: '100vw' })) },
    lazyLoad: { type: Boolean, required: false, default: true },
    fetchPriority: { type: String, required: false, default: '' },
    customClasses: { type: String, required: false, default: '' },
    ariaHidden: { type: String, required: false, default: 'false' },
    objectFit: { type: String, required: false, default: 'cover' },
  },
  computed: {
    cssVars() {
      return {
        '--ratio': this.ratio,
        '--object-fit': this.objectFit,
      };
    },
    loading() {
      return this.lazyLoad && 'lazy';
    },
    computedFetchPriority() {
      return this.fetchPriority?.length ? this.fetchPriority : null;
    },
    xsSrcSet() {
      return generateResizeSrcSet(xsSizes, this.image?.src);
    },
    smSrcSet() {
      return generateResizeSrcSet(smSizes, this.image?.src);
    },
    mdSrcSet() {
      return generateResizeSrcSet(mdSizes, this.image?.src);
    },
    lgSrcSet() {
      return generateResizeSrcSet(lgSizes, this.image?.src);
    },
    renderedSizeMobile() {
      return this.renderedSizes?.mobile || '100vw';
    },
    renderedSizeDesktop() {
      return this.renderedSizes?.desktop || '100vw';
    },
  },
  /* c8 ignore end */
};
</script>
